import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { logInFunctional } from '../../features/login';
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { NavLink } from 'react-router-dom';
import axios from 'axios';
// import { userObj } from '../../DUMMY_DATA';

export default function LoginForm() {
    const [sending, setSending] = useState(false)
    const dispatch = useDispatch()
    // select user
    const login = useSelector((state) => state.login.value);
    // form data
    const { register, handleSubmit, formState: { errors }, getValues, reset
    } = useForm();
    const [data, setData] = useState("");
    // compare passwords  
    const onSubmit = async data => {
        setSending(true)
        setData(JSON.stringify(data));
    };
    // compare passwords end

    // const init = {
    //     method: 'get',
    //     headers: {
    //         'cotnten-type': 'application/json'
    //     },
    //     mode: 'cors',
    //     cache: 'default'
    // }
    // let myRequest = new Request('../../DUMMY_DATA.json', init)
    // fetch(myRequest).then(function (resp) {
    //     return (resp.json)
    // }).then(function (data) {
    //     console.log(data.email)
    // })



    useEffect(() => {
        // if data save data
        if (data) {
            // hide loader
            setSending(false)
            // hide loader end

            dispatch(logInFunctional({ email: getValues("email"), password: getValues("password") }))
            // reset value if success
            reset({
                email: "",
                password: "",
            })



            const init = {
                method: 'get',
                headers: {
                    'content-type': 'application/json',
                    'Accept': 'application/json'
                },
                mode: 'cors',
                cache: 'default'
            }
            let myRequest = new Request('../../DUMMY_DATA.json', init)
            fetch(myRequest)
                .then(function (resp) {
                    // return (resp.json)
                    console.log(resp.json())
                }).then(function (myData) {
                    console.log(myData)
                })

            // axios.post('', {
            //     email: getValues("email"),
            //     password: getValues("password")
            // }).then((response) => {
            //     if (response.user) {
            //         //here user is either the user object or null
            //         //credentials are correct
            //         console.log(true);
            //     } else {
            //         //credentials are wrong
            //         console.log(false);

            //     }
            // }).catch(err => console.log(err))




            // const init = {
            //     method: 'get',
            //     headers: {
            //         'content-type': 'application/json'
            //     },
            //     mode: 'cors',
            //     cache: 'default'
            // }
            // let myRequest = new Request('../../DUMMY_DATA.json', init)
            // fetch(myRequest).then(function (resp) {
            //     return (resp.json)
            // }).then(function (myData) {
            //     console.log(myData.email)
            // })
        }
    }, [data])

    // useEffect(() => {
    //     console.log('login', login);
    // }, [login])
    return (
        <div className='text-black'>
            <form onSubmit={handleSubmit((data) => onSubmit(data))}>

                <div className="w-full md:mr-[0.625rem] pb-4 relative">
                    <label className="input-label" htmlFor="email">Email *</label>
                    <input className="input-field" type="text" {...register("email", {
                        required: "This field is required",
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                            message: "Email format is incorrect"
                        }
                    })} placeholder="email" id="email" />
                    {errors.email ? (
                        <>
                            {/* required error message  */}
                            {errors.email.type === "required" && (
                                <span className="text-formSubSize absolute -bottom-[0.5rem] right-0 text-[#CA0000] pt-1 ">
                                    {errors.email.message}
                                </span>
                            )}
                            {/* format error message  */}

                            {errors.email.type === "pattern" && (
                                <span className="text-formSubSize absolute -bottom-[0.5rem] right-0 text-[#CA0000] pt-1 ">
                                    {errors.email.message}
                                </span>
                            )}
                        </>
                    ) : null}
                </div>

                <div className="w-full md:mr-[0.625rem] pb-4 relative">
                    <label className="input-label" htmlFor="password">Password *</label>
                    <input className="input-field" type="password"  {...register("password", {
                        required: "You must specify a password",
                        minLength: {
                            value: 8,
                            message: "Password must have at least 8 characters"
                        }
                    })} placeholder="password" id="password" />
                    {errors.password && <span className="text-formSubSize absolute -bottom-[0.5rem] right-0 text-[#CA0000] pt-1 ">{errors.password.message}</span>}
                </div>
                <div className="flex pt-14 pb-5 relative">
                    <label className="containerCheckbox">
                        <input type="checkbox" className="checkbox" {...register('remember')} />
                        <span className="text-formSubSize text-white ">Remember Me</span>
                        <span className="checkMark"></span>
                    </label>
                </div>


                {
                    // if we are sending data
                    sending ?
                        <div className="main-button w-fit">
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div> :
                        // after or before send
                        <input type="submit" value={"Create Account"} className="main-button" />
                }
                <div className="text-formSubSize text-white pt-5"> Already a Member? Sign in <NavLink to="/" className="text-mainColor">here.</NavLink></div>
            </form>
        </div>
    )
}
